import React from 'react'
import AddTrack from "./AddTrack";
import TrackTable from './TrackTable'
import { ColorButton } from './AdminTable'
import { Unstable_Grid2 as Grid } from '@mui/material';


const TrackDetails = () => {

  const [openAdd, setOpenAdd] = React.useState(false);

  return (
    <Grid container spacing={2} sx={{marginTop:"5px"}}>
      <Grid xs={12} display="flex" justifyContent="center" alignItems="center">
      {/* <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"                        
            onClick={()=>setOpenAdd(true)}
            sx={{
              "background-color": "white",
              "color": "black",
              "border": "2px solid blueviolet",
              "border-radius": "18px",
              "text-transform": "capitalize",
              "padding": "5px 29px",
              "font-weight": "600",
              "font-size": "14px"              
            }}
          >
            Add Track
        </ColorButton> */}
      <AddTrack              
       openAdd={openAdd}
       setOpenAdd={setOpenAdd}
       />
       </Grid>
       <Grid xs={12} display="flex">
      <TrackTable setOpenAdd={setOpenAdd}/>
       </Grid>
    </Grid>
  )
}

export default TrackDetails